import ContactCorrespondenceAddressModelBase from '../_generated/modelBases/contact-correspondence-address-model-base';

export default class ContactCorrespondenceAddressModel extends ContactCorrespondenceAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
